import { EmailTemplatesSettings } from '@/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_auth/company/$companyId/settings/email-templates',
)({
	component: RouteComponent,
})

function RouteComponent() {
	return <EmailTemplatesSettings />
}
